import React, { useState, useEffect } from 'react'
import { addDays, format } from 'date-fns'
import { DateRange, DayPicker } from 'react-day-picker'
import { isSameDay } from 'date-fns'
import { ko } from 'date-fns/locale'
import 'react-day-picker/dist/style.css'
import styled from 'styled-components'
import colors from '../../styles/colors'

export default function RangeDates({
  range,
  setRange,
  rangeDates,
  setRangeDates,
}) {
  useEffect(() => {
    const addRangeDates = () => {
      if (range) {
        if (range.from && range.to) {
          const start = new Date(range.from + ' UTC')
          const end = new Date(range.to + ' UTC')
          const days = Math.floor((end - start) / (1000 * 60 * 60 * 24))
          const newSelectedDays = [...rangeDates]
          for (let i = 0; i <= days; i++) {
            const currentDate = new Date(
              start.getTime() + i * 24 * 60 * 60 * 1000,
            )
            newSelectedDays.push(currentDate)
            setRangeDates(newSelectedDays)
          }
        }
      }
      //   return rangeDates
    }
    addRangeDates()
  }, [range])

  const handleDayClick = (day, modifiers) => {
    setRangeDates([])
  }
  return (
    // <div className="bg-danger">
    <Wrapper>
      <DayPicker
        mode="range"
        selected={range}
        onSelect={setRange}
        numberOfMonths={2}
        locale={ko}
        onDayClick={handleDayClick}
      />
    </Wrapper>
    // </div>
  )
}
const Wrapper = styled.div`
  .rdp-months {
    width: 578px;
    height: 355px;
    justify-content: center !important;
    border-radius: 8px;
    border: solid 1px #e5e5e5;
    background-color: ${colors.W1};
    padding: 20px 0px;
    @media ${(props) => props.theme.tablet} {
      .rdp-months {
        display: inline-block;
      }
    }

    @media ${(props) => props.theme.tablet} {
      width: 578px;
      .rdp-multiple_months {
        width: 578px;
        margin: auto;
        margin-top: 15px;
      }
    }
    @media ${(props) => props.theme.mobile} {
      border: none;
    }
  }

  .rdp-multiple_months {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rdp-head_cell {
    color: ${colors.mainG};
  }
  .rdp-day_selected,
  .rdp-day_selected:focus-visible,
  .rdp-day_selected:hover {
    background-color: ${colors.mainG} !important;
  }
  .rdp-day_range_middle {
    background-color: ${colors.lightG} !important;
    color: black;
  }
  .rdp-day_today {
    color: ${colors.mainG};
    text-decoration: underline 2px;
  }
  .rdp-day_range_start,
  .rdp-day_range_end {
    color: ${colors.W1} !important;
  }
  .rdp-button:hover:not([disabled]):not(.rdp-day_selected) {
    background-color: ${colors.lightG} !important;
  }
  .rdp-month {
    margin: 0;
  }
  .rdp-month:first-child {
    padding: 20px 0px 20px 20px;
    margin-right: 0.5em;
  }
  .rdp-month:last-child {
    padding: 20px 20px 20px 0px;
  }
  @media ${(props) => props.theme.mobile} {
    .rdp-months {
      display: inline-block;
    }
    .rdp-month:first-child {
      border-radius: 8px;
      border: 1px solid ${colors.G3};
      background-color: ${colors.W1};
      padding: 20px;
    }
    .rdp-month:last-child {
      padding: 20px;
      margin: 0;
      margin-top: 20px;
      border-radius: 8px;
      border: 1px solid ${colors.G3};
      background-color: ${colors.W1};
    }
  }
`
